import {Component, ComponentFactory, EventEmitter, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {DxModalDisplayable} from "../../../../dx-modals/domain/dx-modal-displayable";
import {DxAppEvent} from "../../../../dx-core/domain/events/dx-app-event";

@Component({
  selector: 'pit-file-upload-modal',
  templateUrl: './pit-file-upload-modal.component.html',
  styleUrls: ['./pit-file-upload-modal.component.css']
})
export class PitFileUploadModalComponent implements DxModalDisplayable, OnInit {

  @Output()
  public dirty: EventEmitter<DxAppEvent> = new EventEmitter();

  ctrlDocumentTypeOptions = {
    label: 'Тип документа',
    isSearchable: true,
    useServerSideModel: true,
    datasourceIdent: 'PIT_NCI_BACKEND_COMBO_DS',
    filter: new Map([['DICT_IDENT', 'type_file']])
  };
  fileToUpload: File = null;

  public fileLoadForm: FormGroup = new FormGroup({
    'ctrlDocumentType': new FormControl(),      // Тип файла
    'ctrlNote': new FormControl(),              // Примечание файла
    'ctrlFile': new FormControl()               // Файл
  });
  controls: { [key: string]: AbstractControl } = this.fileLoadForm.controls;

  constructor() { }

  public setInputs(inputs: Map<string, Object>): void {

  }

  public getDirtyNotifier(): EventEmitter<DxAppEvent> {
    return this.dirty;
  }

  handleFileInput(files: FileList) {
    if (files) {
      this.fileToUpload = files.item(0);
    }
  }

  /** возврат значений из модалки */
  public getEditResult(): any {
    const result: Map<string, any> = new Map();
    result.set('ctrlDocumentType', this.controls['ctrlDocumentType'].value);
    result.set('ctrlNote', this.controls['ctrlNote'].value);
    result.set('ctrlFile', this.fileToUpload);
    return result;
  }

  ngOnInit() {
    this.fileLoadForm.valueChanges.subscribe(() => {
      if (this.controls['ctrlFile'].value &&
          this.controls['ctrlDocumentType'].value) {
        this.dirty.emit(new DxAppEvent('pit-file-load-modal'));
      } else {
        this.dirty.emit(new DxAppEvent('pit-file-load-modal', {disableSave: true}));
      }
    });
  }

}
